import { Form } from 'antd';
import styled from 'styled-components';

export const StyledForm = styled(Form)`
  background-color: var(--colorBgContainer);
  max-width: 600px;
  width: 100%;
  padding: 24px;
  border-radius: 4px;

  .ant-input-prefix {
    margin-inline-end: 8px;
  }
`;

export const FormHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;

  img {
    margin: auto;
  }

  .app-title {
    color: #9faecb;
    font-size: 24px;
    font-weight: 500;
    line-height: 1.2;
    text-align: center;
  }

  .page-title {
    font-weight: 500;
    font-size: 35px;
    line-height: 1.2;
  }

  .page-description {
    color: #9faecb;
  }
`;

export const FormFooter = styled.div`
  display: flex;
  justify-content: space-between;

  .ant-btn {
    padding-inline: 20px;
  }
`;
